import { Directive, ElementRef, Input, OnInit, Renderer2, TemplateRef, ViewContainerRef } from '@angular/core';
import { AbstractControl, NgControl, ValidationErrors, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';

@Directive({
    selector: '[formControlName]',
})
export class FormControlAuxiliarDirective implements OnInit {
    @Input('errorMessage') errorMessage: string | {[key: string]: string} | undefined;
    @Input('submitted') submitted: boolean | undefined;

    readonly default_error_messages: {[error: string]: string} = {
        required: 'REQUIRED_FIELD',
        minlength: 'X_CHARACTERS_MINIMUM',
        maxlength: 'X_CHARACTERS_MAXIMUM',
        min: 'X_MINIMUM',
        max: 'X_MAXIMUM'
    }
    readonly htmlInputInvalidClasses: string[] = ['invalid-input'];
    readonly htmlErrorMessageClasses: string[] = ['text-danger', 'fs-8', 'ms-2', 'position-absolute'];


    abstractControl: AbstractControl<any> | null = null;
        
    htmlInput: HTMLInputElement;
    htmlInputLabel: HTMLLabelElement | undefined;

    htmlErrorElement: HTMLElement | undefined;

    languageStreamSubscription?: Subscription

    constructor( 
        private _ngControl: NgControl, 
        private _element: ElementRef,
        private _renderer: Renderer2,
        private _translateService: TranslateService
    ) {        
        this.htmlInput = this._element.nativeElement;

        if (String.isNullOrUndefinedOrWhitespace(this.htmlInput.id)) {
            this.htmlInput.id = this._ngControl.name?.toString() ?? '';
        }
    }

    ngOnInit(): void {
        this.abstractControl = this._ngControl.control;

        if (this.htmlInput.labels != null && this.htmlInput.labels.length > 0) {
            this.htmlInputLabel = this.htmlInput.labels[0];
        } else {
            let counter = 0;
            let nodeList = document.getElementsByTagName('label')

            while (this.htmlInputLabel == null && counter < nodeList.length) {
                if ((nodeList[counter] as HTMLLabelElement).htmlFor == this.htmlInput.id) {
                    this.htmlInputLabel = (nodeList[counter] as HTMLLabelElement);
                }
                counter++;
            }
        }

        if (this.abstractControl) {
            if (this.abstractControl.hasValidator(Validators.required) ) {
                if (this.htmlInputLabel != null) {
                    
                    if (!this.htmlInputLabel.classList.contains('required-input')) {
                        this.htmlInputLabel.classList.add('required-input');
                    }
                }
            }

            this.abstractControl.statusChanges.subscribe( () => {
                if (this.submitted == false || ( this.submitted == undefined && this.abstractControl!.pristine)) {
                    return;
                }
                if (this.abstractControl!.errors != null && Object.entries( this.abstractControl!.errors ).length > 0) {
                    this.htmlInput.classList.add(...this.htmlInputInvalidClasses);
                    this.createErrorMessage();
                } else {
                    if (this.htmlErrorElement) {
                        this.removeErrorMessage();
                    }
                }
            });

        }
    }

    createErrorMessage() {
        let errorMessageElement: HTMLSpanElement;
        let errorMessage = '';
        let errorDetails: string = '';

        if (this.htmlErrorElement) {
            errorMessageElement = this.htmlErrorElement;
        } else {
            errorMessageElement = document.createElement('span') as HTMLSpanElement;
            errorMessageElement.classList.add(...this.htmlErrorMessageClasses);

            this.htmlErrorElement = errorMessageElement;

            this._renderer.appendChild(this.htmlInput.parentElement, this.htmlErrorElement);
        }
        
        if (this.errorMessage && typeof(this.errorMessage) == 'string') {
                errorMessage += this.errorMessage;
        } else {
                
            Object.entries(this.abstractControl!.errors!).some( ([error, errorInfo]) => {
                let errorMessageObject: [string, string] = ['', ''];

                if (this.errorMessage) {
                    errorMessageObject = Object.entries(this.errorMessage as {[key: string]: string}).find( ([searchError, searchErrorMessage]) => error == searchError) ?? ['', ''];
                    
                    if (!String.isNullOrUndefinedOrWhitespace(errorMessageObject?.[1])) {
                        errorMessage = errorMessageObject![1];

                        let errorWithDetails = Object.entries(this.abstractControl?.getError(errorMessageObject[0])).find(([error, errorInfo]) => error == 'requiredLength' || error == 'min' )?.[1];

                        if (errorWithDetails) {
                            errorDetails = (errorWithDetails as number).toString();
                        }

                        return true;
                    }
                } 

                if (String.isNullOrUndefinedOrWhitespace(errorMessage)) {
                    errorMessageObject = Object.entries(this.default_error_messages as {[key: string]: string}).find( ([searchError, searchErrorMessage]) => error == searchError) ?? ['', ''];
                
                    if (!String.isNullOrUndefinedOrWhitespace(errorMessageObject?.[1])) {
                        errorMessage = errorMessageObject![1];

                        let errorWithDetails = Object.entries(this.abstractControl?.getError(errorMessageObject[0])).find(([error, errorInfo]) => error == 'requiredLength' || error == 'min' )?.[1];

                        if (errorWithDetails) {
                            errorDetails = (errorWithDetails as number).toString();
                        }

                        return true;
                    } else {
                        errorMessage = ''
                    }
                }
                

                return false;
            });

        }


        if (!String.isNullOrUndefinedOrWhitespace(errorMessage)) {

            if (this.languageStreamSubscription != null) {
                this.languageStreamSubscription.unsubscribe();
            }

            this.languageStreamSubscription = this._translateService.stream('FORM_VALIDATIONS.' + errorMessage, { x: errorDetails }).subscribe( (translatedMessage) => {
                this.htmlErrorElement!.innerText = translatedMessage;                
            });
        }

        
    }

    removeErrorMessage() {
        this._renderer.removeChild(this.htmlInput.parentElement, this.htmlErrorElement);
        this.htmlErrorElement = undefined;
        this.htmlInput.classList.remove(...this.htmlInputInvalidClasses);
    }
}